/*jshint esversion: 6 */
/*jshint sub:true*/

import Vue from 'vue';
import './plugins/axios';
import Axios from 'axios';


import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import VueSVGCustomIcon from 'vue-svg-custom-icon';
import './directives/directives.js';
import i18n from './plugins/i18n';
import VueQrcodeReader from "vue-qrcode-reader";
import TaktingSocketIO from "./plugins/socket.js";
import 'material-icons/iconfont/material-icons.css';

//mathjs
import { create, all } from 'mathjs';

//printing
import domToImageMore from "./plugins/dom-to-image-more.js";

//global components
import TTooltip from './components/Taktify/TTooltip.component.vue';
import TText from './components/Taktify/TText.component.vue';

Vue.component('TTooltip', TTooltip);
Vue.component('TText', TText);


const config = { };
const math = create(all, config);
//declare as global variable -> use with this.$math
Vue.prototype.$math = math;


Vue.config.productionTip = false;
Vue.config.performance = true;

// Axios
Vue.prototype.$http = Axios;
const token = localStorage.getItem('TAKT_token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Token'] = token;
}

// if (process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'development-server') {
//   Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_BASE_URL;
// } else {
//   Vue.prototype.$http.defaults.baseURL = '/dev-api/API/public/api/v1/';
// }

  Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_BASE_URL;

// SVG Custom Icons
Vue.use(VueSVGCustomIcon, { basePath: '/static' });

// QR Code Reader
Vue.use(VueQrcodeReader);

// Vue.config.errorHandler = function (err, vm, info) {
//   // handle error
//   // `info` is a Vue-specific error info, e.g. which lifecycle hook
//   // the error was found in. Only available in 2.2.0+
// };


// Sockets
Vue.use(TaktingSocketIO);

//printing
Vue.use(domToImageMore);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');
